/* ── ivoltaa-pdp.js — Product Detail Page ── */

/* ── Gallery image switcher ── */
function pdpSetImage(url, thumbEl) {
  var img = document.getElementById('pdp-active-img');
  if (img) img.src = url;
  document.querySelectorAll('.pdp-gallery__thumb').forEach(function(t) {
    t.classList.remove('active');
  });
  if (thumbEl) thumbEl.classList.add('active');
}

/* ── Qty stepper ── */
function pdpQty(delta) {
  var inp = document.getElementById('pdp-qty');
  if (!inp) return;
  var v = parseInt(inp.value, 10) || 1;
  v = Math.max(1, Math.min(99, v + delta));
  inp.value = v;
}

/* ── Variant selection ── */
var pdpSelectedOptions = [];

function pdpSelectOption(el, optIndex, val) {
  var valLabel = document.getElementById('pdp-opt-val-' + optIndex);
  if (valLabel) valLabel.textContent = val;

  var siblings = el.parentElement.querySelectorAll('.pdp-swatch, .pdp-pill');
  siblings.forEach(function(s) {
    s.classList.remove('active');
    s.setAttribute('aria-pressed', 'false');
  });
  el.classList.add('active');
  el.setAttribute('aria-pressed', 'true');

  pdpSelectedOptions[optIndex] = val;

  /* Swap gallery image if swatch has a variant image */
  var imgUrl = el.dataset.img;
  if (imgUrl) pdpSetImage(imgUrl, null);

  var select = document.getElementById('pdp-variant-select');
  if (!select) return;

  Array.from(select.options).forEach(function(opt) {
    var matches = true;
    pdpSelectedOptions.forEach(function(sv, i) {
      if (sv && opt.dataset['opt' + i] !== sv) matches = false;
    });
    if (matches) {
      select.value = opt.value;
      pdpUpdatePrice(opt);
    }
  });
}

function pdpUpdatePrice(opt) {
  if (!opt) return;
  var priceEl   = document.getElementById('pdp-price');
  var compareEl = document.getElementById('pdp-compare');
  var cleanPrice   = opt.dataset.price   ? opt.dataset.price.replace(/<[^>]*>/g, '')   : '';
  var cleanCompare = opt.dataset.compare ? opt.dataset.compare.replace(/<[^>]*>/g, '') : '';
  if (priceEl && cleanPrice) priceEl.textContent = cleanPrice;
  if (compareEl) {
    if (cleanCompare && cleanCompare !== cleanPrice) {
      compareEl.textContent = cleanCompare;
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }
}

/* ── Add to cart ── */
function pdpAddToCart() {
  var select = document.getElementById('pdp-variant-select');
  var qtyEl  = document.getElementById('pdp-qty');
  var qty    = parseInt(qtyEl ? qtyEl.value : 1, 10) || 1;
  var btn    = document.getElementById('pdp-atc');
  if (!select || !btn) return;

  var variantId = select.value;
  var orig = btn.innerHTML;
  btn.innerHTML = 'Adding…';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.innerHTML = '✓ Added!';
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-count, .cart__count, [data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    setTimeout(function() { btn.innerHTML = orig; btn.disabled = false; }, 2000);
  })
  .catch(function() {
    btn.innerHTML = 'Error — try again';
    setTimeout(function() { btn.innerHTML = orig; btn.disabled = false; }, 2000);
  });
}

/* ── Buy now ── */
function pdpBuyNow() {
  var select = document.getElementById('pdp-variant-select');
  var qtyEl  = document.getElementById('pdp-qty');
  var qty    = parseInt(qtyEl ? qtyEl.value : 1, 10) || 1;
  if (!select) return;

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ id: select.value, quantity: qty })
  })
  .then(function() { window.location.href = '/checkout'; })
  .catch(function() { window.location.href = '/cart'; });
}

/* ── Tabs ── */
function pdpTab(btn, panelId) {
  document.querySelectorAll('.pdp-tab').forEach(function(t) {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });
  document.querySelectorAll('.pdp-tab-panel').forEach(function(p) {
    p.classList.remove('active');
    p.hidden = true;
  });
  btn.classList.add('active');
  btn.setAttribute('aria-selected', 'true');
  var panel = document.getElementById('pdp-panel-' + panelId);
  if (panel) { panel.classList.add('active'); panel.hidden = false; }
}

/* ── FAQ accordion ── */
function pdpFaq(btn) {
  var answer   = btn.nextElementSibling;
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  answer.hidden = expanded;
}

/* ── Pincode checker ── */
function pdpCheckPin() {
  var inp = document.getElementById('pdp-pin-input');
  var res = document.getElementById('pdp-pin-result');
  if (!inp || !res) return;
  var val = inp.value.trim();
  if (val.length !== 6 || isNaN(val)) {
    res.textContent = 'Please enter a valid 6-digit pincode.';
    res.className = 'pdp-pin__result pdp-pin__result--err';
    return;
  }
  res.textContent = 'Checking…';
  res.className = 'pdp-pin__result';
  setTimeout(function() {
    res.textContent = '✓ Delivery available in 2–4 business days.';
    res.className = 'pdp-pin__result pdp-pin__result--ok';
  }, 600);
}

/* ── Init on DOM ready ── */
document.addEventListener('DOMContentLoaded', function() {

  /* Allow Enter key in pincode input */
  var pinInput = document.getElementById('pdp-pin-input');
  if (pinInput) {
    pinInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') pdpCheckPin();
    });
  }

  /* Seed pdpSelectedOptions from the currently selected variant */
  var select = document.getElementById('pdp-variant-select');
  if (select && select.selectedOptions.length) {
    var selected = select.selectedOptions[0];
    var i = 0;
    while (selected.dataset['opt' + i] !== undefined) {
      pdpSelectedOptions[i] = selected.dataset['opt' + i];
      i++;
    }
    /* Fix initial price display on load */
    pdpUpdatePrice(selected);
  }

});